module.exports = __webpack_public_path__ + "static/media/node.08a6f0d4.png";